import styled from "styled-components";
import { Breadcrumb } from "semantic-ui-react";

export const StyledBreadcrumb = styled(Breadcrumb)({
  fontSize: ".78571429rem",
  paddingBottom: "1rem",
});
